"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageBackup = void 0;
const date_fns_1 = require("date-fns");
const endOfDay_1 = __importDefault(require("date-fns/endOfDay"));
const endOfYear_1 = __importDefault(require("date-fns/endOfYear"));
const format_1 = __importDefault(require("date-fns/format"));
const startOfDay_1 = __importDefault(require("date-fns/startOfDay"));
const startOfYear_1 = __importDefault(require("date-fns/startOfYear"));
const firestore_1 = require("firebase/firestore");
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const configContext_1 = require("../../context/configContext");
const environment_1 = require("../../environment");
const BookingStatus_1 = require("../../models/BookingStatus");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const useFirestore_1 = require("../../utils/useFirestore");
const DayPickerCustomInput_1 = require("../day-picker/DayPickerCustomInput");
const Spinner_1 = require("../spinner/Spinner");
const ManagerPageBackup = (props) => {
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    // Sync from/to filter values with query parameters.
    const [fromFilter, setFromFilter] = (0, react_1.useState)((0, startOfYear_1.default)((0, date_fns_1.subYears)(new Date(), 3)));
    const [toFilter, setToFilter] = (0, react_1.useState)((0, endOfYear_1.default)((0, date_fns_1.addYears)(new Date(), 1)));
    const minDate = (0, date_fns_1.subYears)(new Date(), 5);
    const maxDate = (0, date_fns_1.addYears)(new Date(), 2);
    const fileInput = (0, react_1.createRef)();
    async function exportData() {
        setIsLoading(true);
        const bookingSnapshot = await (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", config.tenantId), (0, firestore_1.where)("start", ">", (0, startOfDay_1.default)(fromFilter)), (0, firestore_1.where)("start", "<", (0, endOfDay_1.default)(toFilter)), (0, firestore_1.orderBy)("start", "asc"), (0, firestore_1.limit)(10000)));
        const bookingDataWithId = bookingSnapshot.docs.map((doc) => {
            return { id: doc.id, ...doc.data() };
        });
        const tenantDoc = await (0, firestore_1.getDoc)((0, firestore_1.doc)(firestore, "tenants", config.tenantId));
        const tenantDataWithId = { id: tenantDoc.id, ...tenantDoc.data() };
        const data = { tenants: tenantDataWithId, bookings: bookingDataWithId };
        // Replace Firestore timestamps with ISO string dates.
        dateUtils.replaceAllTimestamps(data, (ms) => new Date(ms).toISOString());
        downloadAsJson(data);
        setIsLoading(false);
    }
    function downloadAsJson(data, exportName = `${(0, format_1.default)(new Date(), "yyyy-MM-dd")} Benjibooks Export ` +
        `${(0, environment_1.getEnv)().envName} (${config.tenantId})`) {
        var dataStr = "data:text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(data));
        var downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", exportName + ".json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    }
    async function handleImport(event) {
        setIsLoading(true);
        event.preventDefault();
        var reader = new FileReader();
        reader.readAsText(fileInput.current.files[0], "UTF-8");
        reader.onload = async (evt) => {
            const result = evt.target.result;
            const data = JSON.parse(result);
            // Replace ISO string dates with Firestore Timestamps.
            dateUtils.replaceAllIso(data, (ms) => firestore_1.Timestamp.fromMillis(ms));
            // Import tenant
            const { id, ...tenantData } = data.tenants;
            await (0, firestore_1.setDoc)((0, firestore_1.doc)(firestore, "tenants", id), tenantData);
            // Import bookings.
            const bookings = data.bookings;
            bookings.forEach(async (booking) => {
                const { id, ...bookingData } = booking;
                await (0, firestore_1.setDoc)((0, firestore_1.doc)(firestore, "bookings", id), bookingData);
            });
            setIsLoading(false);
        };
    }
    async function addStatusBooked() {
        setIsLoading(true);
        const bookingSnapshot = await (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", config.tenantId), (0, firestore_1.limit)(1000)));
        let counter = 0;
        bookingSnapshot.docs.forEach((doc) => {
            if (!doc.data().status) {
                console.log(doc.id);
                counter++;
                (0, firestore_1.updateDoc)(doc.ref, { status: BookingStatus_1.BookingStatus.booked.name });
            }
        });
        console.log(counter);
        setIsLoading(false);
    }
    return (react_1.default.createElement(Container_1.default, { className: "mt-5" },
        react_1.default.createElement("h1", null, "Backup"),
        react_1.default.createElement("p", null,
            "Tenant: ",
            config.tenantId,
            react_1.default.createElement("br", null),
            react_1.default.createElement("strong", null,
                "Env: ",
                (0, environment_1.getEnv)().envName)),
        react_1.default.createElement("h3", { className: "mt-5" }, "Export"),
        react_1.default.createElement("div", null,
            react_1.default.createElement(DayPickerCustomInput_1.DayPickerCustomInput, { className: "mb-3", date: fromFilter, onDateChange: (date) => setFromFilter(date), todayButton: "Heute", editable: true, minDate: minDate, maxDate: toFilter }),
            " ",
            "\u2014",
            " ",
            react_1.default.createElement(DayPickerCustomInput_1.DayPickerCustomInput, { className: "mb-3", date: toFilter, onDateChange: (date) => setToFilter(date), todayButton: "Heute", editable: true, minDate: fromFilter, maxDate: maxDate })),
        react_1.default.createElement(Button_1.default, { onClick: exportData, disabled: isLoading }, isLoading ? react_1.default.createElement(Spinner_1.Spinner, null) : react_1.default.createElement(react_1.default.Fragment, null, "Alle Daten exportieren")),
        react_1.default.createElement("br", null),
        react_1.default.createElement("h3", { className: "mt-5" }, "Import"),
        react_1.default.createElement("form", { onSubmit: handleImport },
            react_1.default.createElement("label", { className: "w-100" },
                react_1.default.createElement("input", { className: "w-100", type: "file", ref: fileInput })),
            react_1.default.createElement("br", null),
            react_1.default.createElement("button", { type: "submit" }, "Importieren"))));
};
exports.ManagerPageBackup = ManagerPageBackup;
